import Navbar from "./component/Navbar";
import Home from "./component/Home";
import Apartment from "./component/Apartment";
import Homstel from "./component/Homstel";
import Hostel from "./component/Hostel";
import { Route,Routes } from "react-router-dom";
import Guest_House from "./component/Guest_House";
import Explore from "./component/Explore";
import Frontline from "./component/individual/Frontline";
import Westend from "./component/individual/Westend";
import Delisa from "./component/individual/Delisa";
import {PiPhosphorLogoBold} from 'react-icons/pi'
import Amen from "./component/individual/Amen";
import Fapartment from "./component/individual/Fapartment";
import Knust from "./component/individual/Knust";
import AsantewaGues from "./component/individual/AsantewaGues";
import Okay from "./component/individual/Okay";
import Engineerin from "./component/individual/Engineerin";
import Abank from "./component/individual/Abank";
import Therisa from "./component/individual/Therisa";
import WhiteHouse from "./component/individual/WhiteHouse";
import Nyame from "./component/individual/Nyame";
import Anarosa from "./component/individual/Anarosa";
import Canam from "./component/individual/Canam";
import Noweapon from "./component/individual/Noweapon";
import Adom from "./component/individual/Adom";
import Banivallas from "./component/individual/Banivallas";
import Franko from "./component/individual/Franko";
import Manchester from "./component/individual/Manchester";
import Glory from "./component/individual/Glory";
import Flint from "./component/individual/Flint";
import Morning from "./component/individual/Morning";
import Shallom from "./component/individual/Shallom";
import Jecado from "./component/individual/Jecado";
import Happy from "./component/individual/Happy";
import Fplaza from "./component/individual/Fplaza";
import Fosua from "./component/individual/Fosua";
import Wagingo from "./component/individual/Wagingo";
import Hallowed from "./component/individual/Hallowed";
import P3 from "./component/individual/P3";
import My from "./component/My";
import Loader from "./component/Loader";
import Baffour from "./component/individual/Baffour";
import Js from "./component/individual/Js";
import Fredrick from "./component/individual/Fredrick";
import Osah from "./component/individual/Osah";
import Mocab from "./component/individual/Mocab";
import Single from "./component/individual/Single";
import Ran from "./component/individual/Ran";
import React, { useState } from "react";

export const userContext=React.createContext()

function App() {
  const [search,setsearch]=useState('')
  function hand(e){
    e.preventDefault()
    setsearch(e.target.value)
    console.log(search);
  }
  // filter
  const [toggle,settoggle]=useState(true);
function toggler(){
  settoggle((prev)=>!prev)
  setclick(true)
  setarrow(true)
}
const [arrow,setarrow]=useState(true);
function down(){
  setarrow((prev)=>!prev)
  settoggle(true)
  setclick(true)
}

const [click,setclick]=useState(true);
function onpress(){
  setclick((prev)=>!prev)
  settoggle(true)
  setarrow(true)
  
}
function collapse(){
  settoggle(true)
  setclick(true)
  setarrow(true)
}
// location dropdown
const [location,setlocation]=useState('location')
function Locate(){
  setlocation('location')
}
function Ayeduasi(){
  setlocation('Ayeduasi')
}
function Kotei(){
  setlocation('Kotei')
}
function Newsite(){
  setlocation('Newsite')
}
function Kumasi(){
  setlocation('Kumasi')
}
function KNUSTCampus(){
  setlocation('KNUSTCampus')
}
function Bomsu(){
  setlocation('Bomsu')
}
function TechJunction(){
  setlocation('TechJunction')
}
// price dropdown
const [price,setprice]=useState('price')

function main(){
  setprice('price')
}

function price1(){
  setprice('2300-5500')
}
function price2(){
  setprice('2800-6000')
}
function price3(){
  setprice('6000-17000')
}
function price4(){
  setprice('3000-5000')
}
function price5(){
  setprice('8000-17000')
}
function price6(){
  setprice('2400-4800')
}
function price7(){
  setprice('2300-4500')
}
// type
const [type,settype]=useState('type');
function types(){
  settype('type')
}

function Apartments(){
  settype('Apartment')
}
function GuestHouse(){
  settype('GuestHouse')
}
function homstel(){
  settype('Homestel')
}
function Hostels(){
  settype('Hostel')
}

  return (
    <div className="App "> 
    <userContext.Provider value={[search,hand,setsearch,location,setlocation,Locate,Kotei,Ayeduasi,Newsite,TechJunction,KNUSTCampus,Bomsu,Kumasi,price,setprice,main,price1,price2,price3,price4,price5,price6,price7,type,settype,types,Apartments,GuestHouse,homstel,Hostels,collapse,toggle,settoggle,toggler,arrow,setarrow, down,click,setclick,onpress]}>
      <Routes>
        <Route path="/" element={<Explore />} />
        <Route path="home" element={<Home />} />
        <Route path="Hostel" element={<Hostel />} />
        <Route path="Apartment" element={<Apartment />} />
        <Route path="Homestel" element={<Homstel />} />
        <Route path="Guesthouse" element={<Guest_House />} />
        {/* frontline */}
        <Route path="home/frontline" element={<Frontline />} />
        <Route path="hostel/frontline" element={<Frontline />} />
        {/* westend */}
        <Route path="home/westend" element={<Westend />} />
        <Route path="hostel/westend" element={<Westend />} />
        {/* delisa */}
        <Route path="home/delisa" element={<Delisa />} />
        <Route path="hostel/delisa" element={<Delisa />} />
        {/* amen */}
        <Route path="home/amen" element={<Amen />} />
        <Route path="hostel/amen" element={<Amen />} />
        {/* frontline apartment */}
        <Route path="home/fapartment" element={<Fapartment />} />
        <Route path="hostel/fapartment" element={<Fapartment />} />
        <Route path="apartment/fapartment" element={<Fapartment />} />
        {/* knust guesthouse */}
        <Route path="home/knust" element={<Knust />} />
        <Route path="guesthouse/knust" element={<Knust />} />
        {/* Asantewaa GuestHouse */}
        <Route path="home/yaa" element={<AsantewaGues />} />
        <Route path="guesthouse/yaa" element={<AsantewaGues />} />
        {/* Okay guesthouse */}
        <Route path="home/okay" element={<Okay />} />
        <Route path="guesthouse/okay" element={<Okay />} />
        {/* Engineering */}
        <Route path="home/engineering" element={<Engineerin/>} />
        <Route path="guesthouse/engineering" element={<Engineerin />} />
        {/* Abank GuestHoues */}
        <Route path="home/abank" element={<Abank />} />
        <Route path="guesthouse/abank" element={<Abank />} />
        {/* St Therisa */}
        <Route path="home/therisa" element={<Therisa />} />
        <Route path="hostel/therisa" element={<Therisa />} />
        {/* whitehouse */}
        <Route path="home/whitehouse" element={<WhiteHouse />} />
        <Route path="hostel/whitehouse" element={<WhiteHouse />} />
        {/* Nyame Mereku */}
        <Route path="home/nyame" element={<Nyame />} />
        <Route path="hostel/nyame" element={<Nyame />} />
        {/* Anarosa */}
        <Route path="home/anarosa" element={<Anarosa />} />
        <Route path="hostel/anarosa" element={<Anarosa />} />
        {/* Canam */}
        <Route path="home/canam" element={<Canam />} />
        <Route path="hostel/canam" element={<Canam />} />
        {/* Noweapon */}
        <Route path="home/noweapon" element={<Noweapon />} />
        <Route path="hostel/noweapon" element={<Noweapon />} />
        {/* Adom Bi */}
        <Route path="home/adom" element={<Adom />} />
        <Route path="hostel/adom" element={<Adom />} />
        {/* Banivallas */}
        <Route path="home/Banivallas" element={<Banivallas />} />
        <Route path="hostel/Banivallas" element={<Banivallas />} />
        {/* franko */}
        <Route path="home/franko" element={<Franko />} />
        <Route path="hostel/franko" element={<Franko />} />
        {/* Manchester */}
        <Route path="home/manchester" element={<Manchester />} />
        <Route path="hostel/manchester" element={<Manchester />} />
        {/* Glory to God */}
        <Route path="home/glory" element={<Glory />} />
        <Route path="hostel/glory" element={<Glory />} />
        {/* flint */}
        <Route path="home/flint" element={<Flint />} />
        <Route path="hostel/flint" element={<Flint />} />
        {/* Morning Start */}
        <Route path="home/morning" element={<Morning />} />
        <Route path="hostel/morning" element={<Morning />} />
        {/* shallom */}
        <Route path="home/shallom" element={<Shallom />} />
        <Route path="hostel/shallom" element={<Shallom />} />
        {/* jecado */}
        <Route path="home/jecado" element={<Jecado />} /> 
        <Route path="hostel/jecado" element={<Jecado />} /> 
        {/* happy_family */}
        <Route path="home/happy" element={<Happy />} /> 
        <Route path="hostel/happy" element={<Happy />} /> 
        {/* fplaza */}
        <Route path="home/fplaza" element={<Fplaza />} /> 
        <Route path="hostel/fplaza" element={<Fplaza />} /> 
        {/* Fosua */}
        <Route path="home/fosua" element={<Fosua />} /> 
        <Route path="hostel/fosua" element={<Fosua />} /> 
        {/* wagingo */}
        <Route path="home/wagingo" element={<Wagingo />} />
        <Route path="hostel/wagingo" element={<Wagingo />} />
        {/* Hallowed */}
        <Route path="home/hallowed" element={<Hallowed />} />
        <Route path="hostel/hallowed" element={<Hallowed />} />
        {/* p3 */}
        <Route path="home/p3" element={<P3 />} />
        <Route path="hostel/p3" element={<P3 />} />
        <Route path="guesthouse/loading" element={<Loader />} />
        {/* Bafffour apartment */}
        <Route path="home/baffour" element={<Baffour />} />
        <Route path="apartment/baffour" element={<Baffour />} />
        {/* JS */}
        <Route path="home/js" element={<Js />} />
        <Route path="apartment/js" element={<Js />} />
        {/* Frederick */}
        <Route path="home/fredrick" element={<Fredrick />} />
        <Route path="apartment/fredrick" element={<Fredrick />} />
        {/* Osaah */}
        <Route path="home/osah" element={<Osah />} />
        <Route path="apartment/osah" element={<Osah />} />
        {/* Mocab */}
        <Route path="home/macob" element={<Mocab />} />
        <Route path="apartment/macob" element={<Mocab />} />
        {/* Homstels */}
        <Route path="home/single" element={<Single />} />
        <Route path="homestel/single" element={<Single />} />
        {/* homstel 2 */}
        <Route path="home/ran" element={<Ran />} />
        <Route path="homestel/ran" element={<Ran />} />
        {/* loader */}
        <Route path="loader" element={<Loader />} />
      </Routes>
      </userContext.Provider>
    </div>
  );
}

export default App;
